import { memo } from 'react';
import { Button } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

/**
 * Lines under the filters: how many new people have no access yet (with a Show them link)
 * and what the list leaves out (repeated rows, members with nothing to update).
 *
 * @param {object} props
 * @param {{ newTotal: number, newWithoutAccess: number, unchanged: number }} props.summary
 * @param {() => void} props.onShowThem
 */
function ReviewSummaryLines({ summary, onShowThem }) {
  const { t } = useTranslation('people-access');
  const { newTotal, newWithoutAccess, unchanged } = summary;
  const notListed = [
    unchanged > 0 ? t('import.review.summary.unchanged', { count: unchanged }) : null,
  ].filter(Boolean);

  return (
    <div className="flex flex-col gap-1 text-xs text-content-secondary">
      {newWithoutAccess > 0 ? (
        <p className="flex flex-wrap items-center gap-1">
          <span>
            {t('import.review.summary.noAccess', { count: newWithoutAccess, total: newTotal })}
          </span>
          <Button variant="ghost" size="sm" onClick={onShowThem}>
            {t('import.review.summary.showThem')}
          </Button>
        </p>
      ) : null}
      {notListed.length > 0 ? (
        <p>
          {t('import.review.summary.notListed', {
            parts: notListed.join(t('import.review.summary.and')),
          })}
        </p>
      ) : null}
    </div>
  );
}

export default memo(ReviewSummaryLines);
